import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosInstance } from "../../utils/axios-instance";

export const postProfile = createAsyncThunk(
    "profile/postProfile",
    async (initialProfile) => {
        try {
            const response = await axiosInstance({
                method: "patch",
                url: "/profile",
                data: initialProfile,
            });

            return response.data;
        } catch (error) {
            console.error(error);
            return Promise.reject(error);
        }
    },
);
